.testingAccessModal {
  > .content {
    @media (min-width: 769px) {
      max-width: 27rem;
    }
  }

  .info {
    @media (min-width: 1025px) {
      padding: 0 0.25rem;
    }

    .success {
      max-width: 27rem;
      margin: 0 auto;
      text-align: center;
    }

    .description,
    .hint {
      line-height: 1.375rem;

      @media (min-width: 400px) {
        line-height: 1.75rem;
      }
    }

    .description {
      display: flex;
      flex-direction: column;
      max-width: 23.75rem;
      margin: -0.25rem auto 1.5rem;

      @media (min-width: 400px) {
        max-width: unset;
        margin: -0.125rem auto 1.125rem;
      }

      @media (min-width: 769px) {
        max-width: 23rem;
        margin: -0.25rem 0 1.125rem;
      }
    }

    .hint {
      display: block;
      margin: 1.125rem 0 -0.25rem;
    }
  }
}
